import { ApiSession } from "./common/auth/utils";
import { AuthenticatedUser } from "./common/keycloak/keycloak";
import React from "react";

export interface Plugins {
    dashboardControl: (props: {
        authUser: AuthenticatedUser;
        apiSession: ApiSession | null;
        onLogout: () => Promise<void>;
    }) => React.JSX.Element;
    subscriptionsControl: (props: {
        authUser: AuthenticatedUser;
        apiSession: ApiSession | null;
        onLogout: () => Promise<void>;
    }) => React.JSX.Element;
    invoicesControl: (props: {
        authUser: AuthenticatedUser;
        apiSession: ApiSession | null;
        onLogout: () => Promise<void>;
    }) => React.JSX.Element;
    paymentMethodsControl: (props: {
        authUser: AuthenticatedUser;
        apiSession: ApiSession | null;
        onLogout: () => Promise<void>;
    }) => React.JSX.Element;
}

class PluginRegistry {

    private plugins: Partial<Plugins> = {};

    register<K extends keyof Plugins>(pluginName: K, plugin: Plugins[K]) {
        this.plugins[pluginName] = plugin;
    }

    resolve<K extends keyof Plugins>(pluginName: K): Plugins[K] {

        const plugin = this.plugins[pluginName];

        if (!plugin) {
            throw new Error(`Plugin "${pluginName}" is not registered.`);
        }

        return plugin;
    }
}

export const pluginRegistry = new PluginRegistry();